import { DashboardHeader } from '@modules/admin/Admin.Header'
import AccessControl from '@modules/auth/AccessControl'
import RefreshComponent from '@modules/core/icons/RefreshComponent'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectCountryField from '@modules/formFields/SelectCountryField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import moment from 'moment'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Consultations from '@services/Consultations'
import { MonitoringAcordion } from './monitoring.acordion'
import './monitoring.scss'
import { MonitoringTable } from './monitoring.table'
import CustomModal from '@modules/core/components/CustomModalComponent'

export class Monitoring extends Component {
  clientMonitoring = Consultations.monitoring

  ANSWER_THRESHOLD_WARNING = 2
  ANSWER_THRESHOLD_ERROR = 5

  ROOM_THRESHOLD_WARNING = 30
  ROOM_THRESHOLD_ERROR = 50

  MAX_ANSWER_TIME = 60

  state = {
    onlineProfessionals: [],
    offlineProfessionals: [],
    showModal: false,
    selectedDisconnectProfessional: null,
  }

  getMonitoringData = async (values) => {
    try {
      const requestParams = {
        company_api_keys: values.companies ? values.companies.map((company) => company.api_key) : undefined,
        speciality_ids: values.specialities ? values.specialities.map((speciality) => speciality.id) : undefined,
        country_codes: values.countries ? values.countries.map((country) => country.code) : undefined,
      }

      const monitoringResponse = await this.clientMonitoring.getMonitoringData(requestParams)
      const professionals = monitoringResponse.data

      const onlineProfessionals = professionals
        .filter((professional) => professional.professional_status.chat_label === 'online')
        .sort((a, b) => {
          return b.pending_rooms - a.pending_rooms
        })
        .sort((a, b) => {
          a.sort = !a.nicely_connected ? 0 : 1
          b.sort = !b.nicely_connected ? 0 : 1
          return a.sort - b.sort
        })
        .sort((a, b) => b.professional_status.video_value - a.professional_status.video_value)
        .map((professional) => {
          const answerTime = professional.oldest_room_to_answer_time
            ? moment().diff(moment(professional.oldest_room_to_answer_time, moment.ISO_8601), 'minutes')
            : 0

          let answerTimeColor = 'green'
          if (answerTime > this.ANSWER_THRESHOLD_WARNING) answerTimeColor = 'orange'
          if (answerTime > this.ANSWER_THRESHOLD_ERROR) answerTimeColor = 'red'
          professional.answerTimeColor = answerTimeColor
          professional.answerTime = answerTime < this.MAX_ANSWER_TIME ? answerTime : '+60'
          return professional
        })
      const offlineProfessionals = professionals
        .filter((professional) => professional.professional_status.chat_label === 'offline')
        .sort((a, b) => {
          return b.pending_rooms - a.pending_rooms
        })
        .sort((a, b) => {
          a.sort = !a.nicely_connected ? 0 : moment(a.next_connection_at).unix()
          b.sort = !b.nicely_connected ? 0 : moment(b.next_connection_at).unix()
          return a.sort - b.sort
        })
        .sort((a, b) => b.professional_status.video_value - a.professional_status.video_value)
        .map((professional) => {
          professional.pendingRoomsColor = 'green'
          if (professional.pending_rooms > this.ROOM_THRESHOLD_WARNING) professional.pendingRoomsColor = 'orange'
          if (professional.pending_rooms > this.ROOM_THRESHOLD_ERROR) professional.pendingRoomsColor = 'red'
          return professional
        })

      this.setState({ onlineProfessionals, offlineProfessionals, total: professionals.length })

      return null
    } catch (err) {
      console.error(err)
    }
  }
  openModal = (professional) => {
    this.setState({
      showModal: true,
      selectedDisconnectProfessional: professional,
    })
  }
  disconnectProfessional = async (professional) => {
    try {
      await Consultations.monitoring.disconnectProfessional(professional.id, 0)
      this.setState({
        showModal: false,
        offlineProfessionals: [...this.state.offlineProfessionals, professional],
        onlineProfessionals: this.state.onlineProfessionals.filter((prof) => prof.id !== professional.id),
      })
    } catch (e) {
      console.error(e)
    }
  }

  componentDidMount() {
    setTimeout(this.props.submit, 0)
    this.recursiveFetch = setInterval(this.props.submit, 60000)
  }

  componentWillUnmount() {
    clearTimeout(this.recursiveFetch)
  }

  render() {
    const { submit, t } = this.props
    return (
      <div id="monitoringScreen">
        <Form onSubmit={this.props.handleSubmit(this.getMonitoringData)}>
          <header id="monitoringHeader">
            <DashboardHeader title={<Trans>Monitoreo</Trans>} total={this.state.total}>
              <RefreshComponent actionOnClickRefresh={submit} />
              <Link className="btn btn-primary" to={`/admin`}>
                <Trans>Volver</Trans>
              </Link>
            </DashboardHeader>
            <div className="monitoringFilters">
              <MonitoringAcordion title={<Trans>Filtros</Trans>}>
                <AccessControl requiredRole="super-admin">
                  <Field placeholder={t('Compañías')} name="companies" component={SelectCompanyField} multi />
                </AccessControl>
                <Field placeholder={t('Especialidades')} name="specialities" component={SelectSpecialityField} multi />
                <Field placeholder={t('Países')} name="countries" component={SelectCountryField} multi />
              </MonitoringAcordion>
            </div>
          </header>
        </Form>

        {this.state.showModal && (
          <CustomModal
            title={<Trans>DisconnectConfirmationMonitoring</Trans>}
            active={true}
            actionOnClickClose={() => this.setState({ showModal: false })}
            actionOnClickAccept={() => this.disconnectProfessional(this.state.selectedDisconnectProfessional)}
          />
        )}

        <div className="monitoring-container">
          <MonitoringTable
            professionals={this.state.onlineProfessionals}
            type="online"
            handleOpenModal={this.openModal}
          />
          <MonitoringTable professionals={this.state.offlineProfessionals} type="offline" />
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'monitoringFilters', // a unique identifier for this form
  destroyOnUnmount: false,
})(withTranslation()(Monitoring))
